import TabOrganizer from './tabOrganizer';

export default TabOrganizer;
